(function() {
  const originalAlert = window.alert;
  window.alert = function(message) {
    try {
      const overlay = document.createElement('div');
      overlay.className = 'fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50';
      const modal = document.createElement('div');
      modal.className = 'bg-white p-6 rounded-lg shadow-md text-center flex flex-col items-center';
      modal.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" class="w-12 h-12 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v3m0 4h.01M4.93 4.93l7.07 14.14 7.07-14.14H4.93z" />
        </svg>
        <p class="mt-4 text-black">${message}</p>
        <button class="mt-6 bg-black text-white px-4 py-2 rounded">OK</button>
      `;
      overlay.appendChild(modal);
      document.body.appendChild(overlay);
      modal.querySelector('button').addEventListener('click', () => overlay.remove());
    } catch (e) {
      originalAlert(message);
    }
  };
})();
